export enum ExtraFilterType {
  ConcernAreaFilter = 'concernAreaFilter'
}
